import { FunctionComponent, RefObject } from "react";
import styles from "./card.module.scss";
const Card: FunctionComponent<{
  position?: string;
  children?: string;
  img: string;
  ref?: RefObject<HTMLDivElement>;
}> = ({ position = "", img, children, ref }) => {
  position =
    position === "activeCard"
      ? styles.activeCard
      : position === "prevCard"
      ? styles.prevCard
      : styles.nextCard;
  return (
    <div className={`${styles.card} ${position}`} ref={ref}>
      <img className={styles.image} src={img} alt={"placeholder"} />
    </div>
  );
};

export default Card;
